/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect, useState } from "react";
import DataFilter from "../../common/components/DataFilter";
import DataTable from "../../common/components/DataTable";
import EditableCell from "../../common/components/EditableCell";
import MainLayout from "../../common/components/MainLayout";
import { ActionResult } from "../../common/hooks/useApi";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";
import useConfiguracionesAnaliticaApi, { ConfiguracionAnalitica, ConfiguracionAnaliticaSave } from "../useConfiguracionesAnaliticaApi";
/*

              

*/

export default () => {
    const api = useConfiguracionesAnaliticaApi();
    const createPage = "/neuralvision/configuraciones-analitica/guardar"
    const editPage = "/neuralvision/configuraciones-analitica/guardar/{Id}"

    const unidadesProduccionApi = useUnidadesProduccionAPI();
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();
    const [ nombreFilterForm ] = Form.useForm();

    useEffect(() => {
        unidadesProduccionApi
            .list({ $top: 10000 })
            .then(setUnidadesProduccionResponse)
    }, []);

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
          filters?.Equipo != null ? `contains(Equipo/Nombre,'${filters!.Equipo[0]}')` : "",
        ];    
    }

    return (
        <MainLayout >
            <DataTable<ConfiguracionAnalitica, ConfiguracionAnaliticaSave>
                list={(query) => api.list({ ...query, ...{ $expand: ['Equipo($expand=ConfiguracionProduccion)'] } })}
                delete={api.delete}
                createAction={{
                    label: "Agregar configuración de analítica",
                    path: createPage
                }}
                generateFilters={ generateFilters }
                deleteMultipleAction
                defaultSortOrder={"Id asc"}
                selectionType='checkbox'
                title={"Configuraciones de analítica"}
                editItemAction={editPage}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar configuración de analítica ${item.Id}?`}
                defaultPageSize={25}
            >

                <Table.Column<ConfiguracionAnalitica>
                    width={`10%`}
                    title="ID"
                    dataIndex={"Id"}
                    sorter
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<ConfiguracionAnalitica>
                    width = {`15%`}
                    title = "Equipo"
                    dataIndex = {"Equipo"}  
                    align = "center"                                        
                    defaultSortOrder = {'descend'}
                    sortDirections = {["ascend", "descend", "ascend"]}                    
                    render = {(value) => `${value.Nombre}`}
                    filterDropdown = {(props) => {
                                return (
                                  <DataFilter
                                    filterDropdownProps = {props}
                                    form = {nombreFilterForm}
                                  >
                                    <Form.Item name = {"Equipo"} style = {{ marginBottom: 10 }}>
                                      <Input placeholder = "Nombre de equipo..."></Input>
                                    </Form.Item>
                                  </DataFilter>
                                );
                              }}
                />


                <Table.Column<ConfiguracionAnalitica>
                    width={`20%`}
                    title="Unidad de producción"
                    dataIndex={"Equipo"}
                    defaultSortOrder={'descend'}
                    render={(value) => unidadesProduccionResponse ? unidadesProduccionResponse.data?.value.filter((up) => up.Id == value.ConfiguracionProduccion.UnidadProduccionId)[0].Nombre : '-'}                    
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<ConfiguracionAnalitica>
                    width={`25%`}
                    title="Tipo"
                    dataIndex={"Tipo"}
                    defaultSortOrder={'descend'}
                    render={(value:string) => ({
                        'CRUCE_SEMAFORO': 'Cruce de semáforo',
                        'INVASION_SENDA': 'Invasión de senda peatonal',
                        'ESTADISTICA_CRUCE_SEMAFORO' : 'Estadística de cruce de semáforo'
                    }[value])}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<ConfiguracionAnalitica>
                    width={`25%`}
                    title="Etiqueta"
                    dataIndex={"Etiqueta"}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
            </DataTable>
        </MainLayout>
    );

};